import { useTranslation } from 'react-i18next';

/**
 * Typed wrapper around useTranslation.
 * In future, we can add compile-time key checking here.
 */
export function useTypedTranslation() {
  const { t, i18n } = useTranslation();
  return { t, i18n };
}
